// TODO(Sergio): Temporary skip eslint rules, this is part of the A6-A12 migration from mono-frontend
/* eslint-disable */
import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  Directive,
  ElementRef,
  Inject,
  Input,
  PLATFORM_ID
} from '@angular/core';
import { GeneralStyleObject } from '../../models/ui.interfaces';

@Directive({
  selector: '[idpTooltipPosition]'
})
export class TooltipPositionDirective implements AfterViewInit {
  @Input() hostElementRef: any;
  @Input() adjustPos = { top: 0, right: 0, left: 0, bottom: 0 };
  @Input() maxWidth = true;

  constructor(
    private el: ElementRef,
    // tslint:disable-next-line
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngAfterViewInit() {
    this.validateElement();
  }

  /**
   * Validate if element exist previous to display the tooltip
   *
   */
  validateElement() {
    if (isPlatformBrowser(this.platformId)) {
      if (
        this.hostElementRef &&
        this.el &&
        this.el.nativeElement &&
        this.el.nativeElement.children &&
        this.el.nativeElement.children[0]
      ) {
        const targetElement = this.el.nativeElement.children[0];

        if (this.hostElementRef && targetElement) {
          this.setPosition(this.hostElementRef, targetElement);
        }
      }
    }
  }

  /**
   * This method sets the position of targetElement (tooltip)
   * to its generating hostelement
   * @param hostElement- element which initiates the error tooltip &
   * tooltip needs to be positioned relative to this component
   * @param targetElement- tooltip component element itself,
   * which needs to be positioned
   */
  setPosition(hostElement: any, targetElement: any): void {
    const hostEleProps = hostElement.getBoundingClientRect();
    const pseudoElStyles: GeneralStyleObject = this.getPseudoElement(
      targetElement,
      ':after'
    );
    const targetElProps = targetElement.getBoundingClientRect();
    const topPosition =
      hostEleProps.top -
      targetElProps.top -
      (targetElProps.height + pseudoElStyles.height) +
      this.adjustPos.top;
    const leftPosition =
      hostEleProps.left +
      hostEleProps.width / 2 -
      (targetElProps.left + targetElProps.width) +
      (pseudoElStyles.marginRight + pseudoElStyles.width / 2) +
      this.adjustPos.left;
    targetElement.style.transform = `translate(${leftPosition}px, ${topPosition}px)`;
    if (this.maxWidth) {
      const paraentElWidth =
        targetElement.offsetLeft + targetElement.offsetWidth;
      targetElement.style.maxWidth = `${
        paraentElWidth - Math.abs(leftPosition)
      }px`;
    }
  }

  /**
   * this retrieves any pseudo element like :after, :before,
   * to the target element & return a object with its associated
   * styles
   * @param targetElement: element having pseudo element
   * @returns a object with its associated styles
   */
  getPseudoElement(
    targetElement: HTMLElement,
    type: string
  ): GeneralStyleObject {
    const styles = window.getComputedStyle(targetElement, type);
    const height = styles && styles.height ? parseFloat(styles.height) : 0;
    const width = styles && styles.width ? parseFloat(styles.width) : 0;
    const marginRight =
      styles && styles.marginRight ? parseFloat(styles.marginRight) : 0;
    const marginLeft =
      styles && styles.marginLeft ? parseFloat(styles.marginLeft) : 0;
    const el = {
      height,
      width,
      marginRight,
      marginLeft
    } as GeneralStyleObject;
    return el;
  }
}
